

















































import { Vue, Component } from 'vue-property-decorator';
import PickerInput from '../components/PickerInput.vue';
import { Popup, Picker, Toast } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import clounbtn from '../components/CloundbtnInfo.vue';
import { saveuser, checkUser, updateuser } from '../api';
import qs from 'qs';

@Component({
  components: {
    PickerInput,
    clounbtn,
  },
})
export default class Rule extends Vue {
  subbtn: any = require('../assets/info/infobtn.png');
  rulecontent: any = '';
  name: string = '';
  unionid: string | null = '';
  options: any = ['抖音', '微博', '小红书', 'b站'];
  platform: string = '';
  platformId: string = '';
  schname: string = '';
  phone: string = '';

  mounted() {
    this.unionid = window.localStorage.getItem('unionid');
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      return false;
    } else if (
      (this.unionid === null || this.unionid === 'null') &&
      isWeiXin()
    ) {
      this.WechatLogin();
      return false;
    }
    checkUser(this.unionid + '').then((res: any) => {
      if (res.code === 200) {
        this.name = res.data.name;
        this.phone = res.data.phone;
        this.schname = res.data.schname;
        this.platform = res.data.platform;
        this.platformId = res.data.platformId;
      } else {
        this.$router.go(-1);
        Toast(res.msg);
      }
    });
  }
  goback() {
    this.$router.push('index');
  }
  selectData1(e: any) {
    this.platform = e + '';
  }
  submitInfo() {
    if (!this.name) {
      Toast('请填写姓名！');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      return false;
    } else if (!this.schname) {
      Toast('请输入学校名称！');
      return false;
    } else if (!this.platform) {
      Toast('请选择平台！');
      return false;
    } else if (!this.platformId) {
      Toast('请输入平台ID！');
      return false;
    } else {
      this.submitPerson();
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx536e2bb3e4f6664f';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async submitPerson() {
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      return false;
    } else if (
      (this.unionid === null || this.unionid === 'null') &&
      isWeiXin()
    ) {
      this.WechatLogin();
      return false;
    }
    const data = {
      unionid: this.unionid,
      name: this.name,
      phone: this.phone,
      platform: this.platform,
      platformId: this.platformId,
      schname: this.schname,
    };
    updateuser(data).then((res: any) => {
      if (res.code === 200) {
        this.$router.push('succesinfo');
      } else {
        Toast(res.msg);
      }
    });
  }
}
